import { Badge, type BadgeProps } from "@/components/ui/badge";
import { PRIORITY, type ValueRenderer } from "../types";

const STATUS_KEYS = new Set(["status", "state"]);
const SUCCESS_WORDS = new Set(["success", "ok", "completed", "complete", "won", "active"]);
const FAILURE_WORDS = new Set(["failure", "failed", "error", "lost", "cancelled", "canceled"]);
const PENDING_WORDS = new Set(["pending", "running", "waiting", "scheduled"]);

function variantFor(word: string): BadgeProps["variant"] {
  const w = word.toLowerCase();
  if (SUCCESS_WORDS.has(w)) return "success";
  if (FAILURE_WORDS.has(w)) return "destructive";
  if (PENDING_WORDS.has(w)) return "warning";
  return "default";
}

export const StatusRenderer: ValueRenderer = {
  id: "status",
  match: (value, ctx) => {
    if (typeof value !== "string" || value.length > 24) return null;
    if (ctx.key && STATUS_KEYS.has(ctx.key.toLowerCase())) return { priority: PRIORITY.CONTEXT_HINTED };
    return null;
  },
  Component: ({ value }) => <Badge variant={variantFor(value as string)}>{value as string}</Badge>,
};
